type TImagePropsKit = React.ImgHTMLAttributes<HTMLImageElement> & {
  loading: "lazy" | "eager";
  srcset?: string;
  sizes?: string;
  fetchpriority?: "high" | "low";
  src: string | React.ReactNode;
};

const Image = (props: TImagePropsKit) => {
  return <img {...props} />;
};

Image.defaultProps = {
  alt: "Trio",
  fetchpriority: "low",
  loading: "lazy",
};

export default Image;
